import { render } from "./ChatWindow.vue?vue&type=template&id=13c33e70"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"

import "./ChatWindow.vue?vue&type=style&index=0&id=13c33e70&lang=css"
script.render = render

export default script